/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useState } from "react";
import {
  ChevronUpIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/24/outline";
import { MicrophoneIcon, StopIcon } from "@heroicons/react/24/solid";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { useLocation, useNavigate } from "react-router-dom";
import { DateRange, getQuarterRanges } from "./convertionHealper";
import moment from "moment";
import { useManageIPMSContext } from "./ManageIPMSContex";
import {
  GetGoalsAssessmentsResponse,
  QuartersResponse,
  trainingPlan,
  UpdateGoalsAssessmentsPayload,
} from "../../model/ipmsmodel";
import GoalsAssessmentReview from "./goalsAssessmentReview";
import { TrainingPlanSaveEntry } from "./newipmsmodel";
import AssessmentFileUpload from "./FileUploadComponent";

// import { getCookieData } from "../../helper/api";
import {
  GoalsAssessmentFinalStatusProgressbarSEnum,
  GoalsAssessmentFinalStatusProgressbarSEnumOther,
  GoalsAssessmentFinalStatusSEnum,
  GoalsAssessmentFinalStatusSEnumother,
  GoalsAssessmentFinalStatuswaitingSEnumother,
  GoalsAssessmentFinalwaitingStatusSEnum,
  GoalsAssessmentFlagStatusEnumTextCap,
  GoalsFlagStatusEnumTextCap,
  USERROLEENUM,
} from "./constant";
import IPMSCustomTable, { Column } from "./IPMSTable";
import { getCookieData } from "../../helper/api";
import { useAuth } from "../../context/LoginContext";
import { toast } from "react-toastify";

interface SpeechTextAreaProps {
  value: string;
  disabled: boolean;
  readOnly?: boolean;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const SpeechTextArea: React.FC<SpeechTextAreaProps> = ({
  value,
  disabled,
  readOnly,
  onChange,
  placeholder,
  className,
}) => {
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();

  const baseTextRef = React.useRef(value || "");
  const [isListeningLocal, setIsListeningLocal] = React.useState(false);
  const textareaRef = React.useRef<HTMLTextAreaElement>(null);

  // Auto-scroll to bottom when value changes
  React.useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
  }, [value]);

  React.useEffect(() => {
    if (!listening) {
      setIsListeningLocal(false);
    }
  }, [listening]);

  React.useEffect(() => {
    if (listening && isListeningLocal) {
      if (transcript) {
        const baseText = baseTextRef.current;
        const separator = baseText && baseText.trim().length > 0 ? " " : "";
        const newValue = baseText + separator + transcript;
        if (newValue !== value) {
          onChange(newValue);
        }
      }
    } else if (!listening) {
      if (value) {
        baseTextRef.current = value;
      }
    }
  }, [transcript, listening, isListeningLocal, onChange, value]);

  return (
    <div className="relative h-full">
      <textarea
        ref={textareaRef}
        disabled={disabled}
        readOnly={readOnly}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className={className}
        placeholder={placeholder}
        rows={4}
      />
      {/* {browserSupportsSpeechRecognition && !disabled && !readOnly && (
        <button
          type="button"
          onClick={() => {
            if (listening) {
              SpeechRecognition.stopListening();
            } else {
              baseTextRef.current = value || "";
              resetTranscript();
              setIsListeningLocal(true);
              SpeechRecognition.startListening({
                continuous: true,
                language: "en-IN",
              });
            }
          }}
          title="Dictate"
          className={`absolute top-2 right-5 p-1 rounded-full transition-all shadow-sm hover:shadow-md active:scale-95 cursor-pointer ${
            listening && isListeningLocal
              ? "bg-red-500 text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          }`}
        >
          {listening && isListeningLocal ? (
            <StopIcon className="w-4 h-4" />
          ) : (
            <MicrophoneIcon className="w-4 h-4" />
          )}
        </button>
      )} */}
    </div>
  );
};

interface AccordionItemProps {
  title: string;
  content: React.ReactNode;
  icon?: React.ReactNode;
  isOpen?: boolean;
  dateRange: DateRange;
  status?: string;
}

const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  content,
  isOpen = false,
  dateRange,
  status,
}) => {
  const [open, setOpen] = useState(isOpen);

  const toggleAccordion = () => setOpen(!open);

  const getStatusBadge = (status: string | undefined) => {
    if (!status) return null;
    let bgColor = "bg-gray-200 text-gray-800";
    let displayText = status;
    switch (status.toUpperCase()) {
      case "READY":
      case "DRAFT":
        bgColor = "bg-red-100 text-red-600 border-red-300";
        displayText = "Employee Saved";
        break;
      case "SUBMITTED":
        bgColor = "bg-red-100 text-red-700 border-red-200";
        displayText = "Employee Submitted";
        break;
      case "APPROVED":
        bgColor = "bg-indigo-100 text-indigo-700 border-indigo-200";
        displayText = "Manager Approved";
        break;
      case "COMPLETED":
        bgColor = "bg-green-100 text-green-700 border-green-200";
        displayText = "HR Approved";
        break;
      default:
        break;
    }

    return (
      <span
        className={`text-[10px] font-bold px-2.5 py-0.5 rounded-full border ${bgColor} uppercase tracking-wider`}
      >
        {displayText}
      </span>
    );
  };

  return (
    <div className="mb-2">
      <h2>
        <button
          type="button"
          className={`flex items-center justify-between w-full p-5 text-gray-800 font-semibold border  border-gray-200  ${
            open ? "rounded-0" : "rounded-0"
          } bg-green-50 hover:bg-green-100 transition-colors duration-200  gap-3 focus:ring-0 `}
          onClick={toggleAccordion}
          aria-expanded={open}
          aria-controls="accordion-content"
        >
          <div className="flex items-center justify-between gap-4 flex-1">
            <span className="flex items-center">
              Review Of {title} Goals -
              <span className="text-sm">
                (
                {dateRange &&
                  dateRange.start &&
                  moment(dateRange.start).format("DD MMM YYYY")}
                &nbsp; to &nbsp;
                {dateRange &&
                  dateRange.end &&
                  moment(dateRange.end).format("DD MMM YYYY")}
                )
              </span>
            </span>
            {getStatusBadge(status)}
          </div>
          <ChevronUpIcon
            className={`w-5 h-5 ${open ? "rotate-180" : ""} shrink-0 transition-transform duration-200`}
          />
        </button>
      </h2>
      {open && (
        <div
          id="accordion-content"
          className="p-5 border border-gray-200 border-t-0 dark:border-gray-700"
        >
          {content}
        </div>
      )}
    </div>
  );
};

export interface GoalsAssessmentContentProps {
  id: string | null;
  quarterName: string;
  submissionstatus?: number;
  formType: string;
  assessmentData: { start: string; end: string };
  employeeID: number;
  isViewOnly?: boolean;
}

export const GoalsAssessmentContent: React.FC<GoalsAssessmentContentProps> = ({
  id,
  quarterName,
  submissionstatus,
  formType,
  assessmentData,
  employeeID,
  isViewOnly = false,
}) => {
  // Build a state object from props so all internal logic stays unchanged
  const state = {
    id,
    quarterName,
    submissionstatus,
    formType,
    assessmentData,
    employeeID,
  };

  const navigate = useNavigate();
  const [errorMessage, setErrormessage] = useState("");
  const {
    GetIpmsEmployeeGoalAssessmentData,
    GetEmployeeGoalAssessment,
    updateGoalsAssessmentsDataByEmployee,
    updateGoalsAssessmentsDataByManager,
    updateGoalsAssessmentsDataByHr,
    rejectGoalsAssessmentsData,
    dispatch,
  } = useManageIPMSContext();

  const { user } = useAuth();
  const userRole = getCookieData("roleId")
    ? Number(getCookieData("roleId"))
    : user
      ? user.role_id
      : null;

  React.useEffect(() => {
    const data = state?.id && state?.id.toString();
    if (typeof data === "string") {
      const payload = {
        employee_id: state?.employeeID as number,
        assessment_year: moment(state?.assessmentData.start).year(),
        quarter: Number(data),
      };
      GetEmployeeGoalAssessment(payload);
    } else {
      console.error(
        "state.id is not a valid string or is undefined:",
        state?.id,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.employeeID, state?.id]);

  const currentQuarterKey = state?.quarterName
    ? String(state.quarterName).startsWith("q")
      ? state.quarterName
      : "q" + state.quarterName
    : "";
  const currentQuarterData =
    GetIpmsEmployeeGoalAssessmentData &&
    currentQuarterKey &&
    GetIpmsEmployeeGoalAssessmentData[currentQuarterKey];

  const getStatusNumber = (status: string | undefined) => {
    console.log("status", status);
    if (!status) return GoalsFlagStatusEnumTextCap.DRAFT;
    switch (status.toUpperCase()) {
      case "DRAFT":
        return GoalsFlagStatusEnumTextCap.DRAFT;
      case "SUBMITTED":
        return GoalsFlagStatusEnumTextCap.SUBMITTED;
      case "APPROVED":
        return GoalsFlagStatusEnumTextCap.APPROVED;
      default:
        return "";
    }
  };

  const getAssessmentStatusNumber = (status: string | undefined) => {
    console.log("status", status);
    if (!status) return GoalsAssessmentFlagStatusEnumTextCap.READY;
    switch (status.toUpperCase()) {
      case "READY":
        return GoalsAssessmentFlagStatusEnumTextCap.READY;
      case "SUBMITTED":
        return GoalsAssessmentFlagStatusEnumTextCap.SUBMITTED;
      case "APPROVED":
        return GoalsAssessmentFlagStatusEnumTextCap.APPROVED;
      case "COMPLETED":
        return GoalsAssessmentFlagStatusEnumTextCap.COMPLETED;
      default:
        return "";
    }
  };

  const goalSubmitedStatus = getStatusNumber(
    currentQuarterData && typeof currentQuarterData !== "string"
      ? currentQuarterData.header?.goal_status
      : undefined,
  );
  const goalSubmitedAssessmentStatus = getAssessmentStatusNumber(
    currentQuarterData && typeof currentQuarterData !== "string"
      ? currentQuarterData.header?.assessment_status
      : undefined,
  );

  const validateManagerJSON = (data: any, targetQuarter: string): boolean => {
    const payload = data[targetQuarter];
    if (!payload) return true;

    if (state.formType === "ManageInput" && targetQuarter === "q4") {
      if (!payload.header?.final_rating) {
        setErrormessage("Please select Final Rating");
        return false;
      }
    }

    if (payload.goals) {
      for (const item of payload.goals) {
        if (
          item.mgr_rating === null ||
          item.mgr_rating === undefined ||
          item.mgr_rating === ""
        ) {
          setErrormessage(
            `In ${targetQuarter.toUpperCase()}, Please enter all Manager required fields in KRA's (Manager Rating)`,
          );
          return false;
        }
      }
    }

    if (payload.soft_goals) {
      for (const item of payload.soft_goals) {
        if (
          item.mgr_rating === null ||
          item.mgr_rating === undefined ||
          item.mgr_rating === ""
        ) {
          setErrormessage(
            `In ${targetQuarter.toUpperCase()}, Please enter all Manager required fields in Soft Goals (Manager Rating)`,
          );
          return false;
        }
      }
    }

    if (
      payload.header?.bonus_rating === null ||
      payload.header?.bonus_rating === undefined ||
      payload.header?.bonus_rating === ""
    ) {
      setErrormessage(
        `In ${targetQuarter.toUpperCase()}, Please enter all required fields in Other (Bonus Rating)`,
      );
      return false;
    }
    return true;
  };

  const validateEmployeeJSON = (data: any, targetQuarter: string): boolean => {
    const payload = data[targetQuarter];
    if (!payload) return true;

    if (payload.goals) {
      for (const [index, item] of payload.goals.entries()) {
        if (
          item.self_rating === null ||
          item.self_rating === undefined ||
          item.self_rating === ""
        ) {
          setErrormessage(
            `In ${targetQuarter.toUpperCase()}, Please enter all Employee required fields in KRA's (Self Rating)`,
          );
          return false;
        }

        if (
          item.percent_met === null ||
          item.percent_met === undefined ||
          item.percent_met === ""
        ) {
          setErrormessage(
            `In ${targetQuarter.toUpperCase()}, Please enter percentage met in KRA's`,
          );
          return false;
        }

        const value = parseFloat(String(item.percent_met));
        if (isNaN(value) || value <= 0 || value > 100) {
          setErrormessage(
            `In ${targetQuarter.toUpperCase()}, please enter a valid MET value between 0 and 100 in KRA's.`,
          );
          setTimeout(() => {
            const element = document.getElementById(
              `${targetQuarter}-goals-percent_met-${index}`,
            );
            if (element) {
              element.scrollIntoView({ behavior: "smooth", block: "center" });
              element.focus({ preventScroll: true });
            }
          }, 300);
          return false;
        }
      }
    }

    if (payload.org_goals) {
      for (const item of payload.org_goals) {
        if (
          item.is_adhered === null ||
          item.is_adhered === undefined ||
          item.is_adhered === ""
        ) {
          setErrormessage(
            `In ${targetQuarter.toUpperCase()}, Please enter all Employee required fields in Org Goals (Adhering to Goal)`,
          );
          return false;
        }
      }
    }

    if (payload.soft_goals) {
      for (const item of payload.soft_goals) {
        if (
          item.self_rating === null ||
          item.self_rating === undefined ||
          item.self_rating === ""
        ) {
          setErrormessage(
            `In ${targetQuarter.toUpperCase()}, Please enter all Employee required fields in Soft Goals (Self Rating)`,
          );
          return false;
        }
      }
    }

    return true;
  };

  const validateHrJSON = (data: any, targetQuarter: string): boolean => {
    const payload = data[targetQuarter];
    if (!payload) return true;

    if (
      !payload.header?.hr_extra_comments ||
      payload.header?.hr_extra_comments.trim() === ""
    ) {
      setErrormessage("Please enter HR Inputs");
      return false;
    }
    return true;
  };

  // handle employee submit
  const handleEmployeeSubmit = useCallback(
    async (status: string, IpmsData: any) => {
      console.log("IpmsData (Employee)", IpmsData, status);
      if (status && IpmsData) {
        setErrormessage("");
        // String(state.quarterName) === '4' ? ['q1', 'q2', 'q3', 'q4'] :
        const quartersToProcess = ["q" + state.quarterName];

        for (const q of quartersToProcess) {
          if (!validateEmployeeJSON(IpmsData, q)) return;
        }

        try {
          const allRatings: any[] = [];
          for (const q of quartersToProcess) {
            const qData = IpmsData[q];
            if (qData) {
              const qStatus = qData.header?.assessment_status;
              if (
                qStatus === GoalsAssessmentFlagStatusEnumTextCap.APPROVED ||
                qStatus === GoalsAssessmentFlagStatusEnumTextCap.COMPLETED
              ) {
                continue;
              }
              allRatings.push(
                ...(qData.goals || []).map((item: any) => ({
                  id: item.id,
                  self_rating: item.self_rating,
                  self_comment: item.self_comment,
                  mgr_rating: item.mgr_rating,
                  mgr_comment: item.mgr_comment,
                  percent_met: item.percent_met,
                })),
                ...(qData.soft_goals || []).map((item: any) => ({
                  id: item.id,
                  self_rating: item.self_rating,
                  self_comment: item.self_comment,
                  mgr_rating: item.mgr_rating,
                  mgr_comment: item.mgr_comment,
                })),
                ...(qData.org_goals || []).map((item: any) => ({
                  id: item.id,
                  is_adhered: item.is_adhered,
                  self_comment: item.self_comment,
                  mgr_comment: item.mgr_comment,
                })),
              );
            }
          }

          const EmployesRequired = {
            employee_id: state.employeeID,
            assessment_year: state?.assessmentData?.start
              ? moment(state.assessmentData.start).year()
              : moment().year(),
            quarter: Number(state?.quarterName) as 1 | 2 | 3 | 4,
            is_submit: status === "Submit",
            emp_overall_comment:
              IpmsData[currentQuarterKey]?.header?.emp_overall_comment || null,
            emp_extra_comments:
              IpmsData[currentQuarterKey]?.header?.emp_extra_comments || null,
            training_plans:
              IpmsData["q4"]?.training?.map((t: any) => ({
                id: t.id,
                area_of_development: t.area_of_development,
                action_steps: t.action_steps,
                //timeline: t.timeline,
                timeline: t.timeline === "" ? null : t.timeline,
              })) || [],
            ratings: allRatings,
          };
          await updateGoalsAssessmentsDataByEmployee(
            EmployesRequired,
            "EmployeeInput",
          );
        } catch (error) {
          console.error("Error in handleEmployeeSubmit:", error);
        }
      } else {
        console.warn("No status provided, not submitting data");
      }
    },
    [state, updateGoalsAssessmentsDataByEmployee],
  );

  // handle manager submit
  const handleManagerSubmit = useCallback(
    async (status: string, IpmsData: any) => {
      console.log("IpmsData (Manager)", IpmsData, status);
      console.log(Number(state?.quarterName) as 1 | 2 | 3 | 4);
      if (status && IpmsData) {
        setErrormessage("");
        // String(state.quarterName) === '4' ? ['q1', 'q2', 'q3', 'q4'] :
        const quartersToProcess = ["q" + state.quarterName];

        if (status === GoalsAssessmentFlagStatusEnumTextCap.APPROVED) {
          for (const q of quartersToProcess) {
            if (!validateManagerJSON(IpmsData, q)) return;
          }
        }
        try {
          const allRatings: any[] = [];
          for (const q of quartersToProcess) {
            const qData = IpmsData[q];
            if (qData) {
              const qStatus = qData.header?.assessment_status;
              if (
                qStatus === GoalsAssessmentFlagStatusEnumTextCap.COMPLETED ||
                (status === GoalsAssessmentFlagStatusEnumTextCap.APPROVED &&
                  qStatus === GoalsAssessmentFlagStatusEnumTextCap.APPROVED)
              ) {
                continue;
              }
              allRatings.push(
                ...(qData.goals || []).map((item: any) => ({
                  id: item.id,
                  mgr_rating:
                    status === GoalsAssessmentFlagStatusEnumTextCap.APPROVED
                      ? item.mgr_rating
                      : null,
                  mgr_comment:
                    status === GoalsAssessmentFlagStatusEnumTextCap.APPROVED
                      ? item.mgr_comment
                      : "",
                })),
                ...(qData.soft_goals || []).map((item: any) => ({
                  id: item.id,
                  mgr_rating:
                    status === GoalsAssessmentFlagStatusEnumTextCap.APPROVED
                      ? item.mgr_rating
                      : null,
                  mgr_comment:
                    status === GoalsAssessmentFlagStatusEnumTextCap.APPROVED
                      ? item.mgr_comment
                      : "",
                })),
                ...(qData.org_goals || []).map((item: any) => ({
                  id: item.id,
                  is_adhered:
                    status === GoalsAssessmentFlagStatusEnumTextCap.APPROVED
                      ? item.is_adhered
                      : null,
                  mgr_comment:
                    status === GoalsAssessmentFlagStatusEnumTextCap.APPROVED
                      ? item.mgr_comment
                      : "",
                })),
              );
            }
          }

          const ManagerRequired = {
            employee_id: state.employeeID,
            assessment_year: state?.assessmentData?.start
              ? moment(state.assessmentData.start).year()
              : moment().year(),
            quarter: Number(state?.quarterName) as 1 | 2 | 3 | 4,
            status: status,
            mgr_extra_comments:
              status === GoalsAssessmentFlagStatusEnumTextCap.APPROVED
                ? IpmsData[currentQuarterKey]?.header?.mgr_extra_comments ||
                  null
                : "",
            mgr_overall_comment:
              status === GoalsAssessmentFlagStatusEnumTextCap.APPROVED
                ? IpmsData[currentQuarterKey]?.header?.mgr_overall_comment ||
                  null
                : "",
            mgr_rating_kra:
              status === GoalsAssessmentFlagStatusEnumTextCap.APPROVED
                ? IpmsData[currentQuarterKey]?.header?.mgr_rating_kra || null
                : null,
            mgr_rating_soft:
              status === GoalsAssessmentFlagStatusEnumTextCap.APPROVED
                ? IpmsData[currentQuarterKey]?.header?.mgr_rating_soft || null
                : null,
            bonus_rating:
              status === GoalsAssessmentFlagStatusEnumTextCap.APPROVED
                ? IpmsData[currentQuarterKey]?.header?.bonus_rating || null
                : null,
            final_rating:
              status === GoalsAssessmentFlagStatusEnumTextCap.APPROVED
                ? IpmsData[currentQuarterKey]?.header?.final_rating || null
                : null,
            ratings: allRatings,
          };

          console.log("ManagerRequired", ManagerRequired);
          await updateGoalsAssessmentsDataByManager(
            ManagerRequired,
            "ManagerInput",
          );
        } catch (error) {
          console.error("Error in handleManagerSubmit:", error);
        }
      } else {
        console.warn("No status provided, not submitting data");
      }
    },
    [state, updateGoalsAssessmentsDataByManager],
  );

  const handleHrSubmit = useCallback(
    async (status: string, IpmsData: any) => {
      console.log("IpmsData (Hr)", IpmsData, status);
      if (status && IpmsData) {
        const currentQuarterKey = "q" + state.quarterName;
        if (status === GoalsAssessmentFlagStatusEnumTextCap.COMPLETED) {
          if (!validateHrJSON(IpmsData, currentQuarterKey)) return;
        }
        try {
          setErrormessage("");
          const HrRequired = {
            employee_id: state.employeeID,
            assessment_year: moment(state?.assessmentData.start).year(),
            quarter: Number(state?.quarterName) as 1 | 2 | 3 | 4,
            status: status,
            hr_extra_comments:
              IpmsData[currentQuarterKey]?.header?.hr_extra_comments || null,
          };
          await updateGoalsAssessmentsDataByHr(HrRequired, "HrInput");
        } catch (error) {
          console.error("Error in handleManagerSubmit:", error);
        }
      } else {
        console.warn("No status provided, not submitting data");
      }
    },
    [state, updateGoalsAssessmentsDataByHr],
  );

  // reject goals assessment
  const rejectGoalsAssessment = useCallback(
    async (status: string, IpmsData: GetGoalsAssessmentsResponse | null) => {
      if (status && IpmsData) {
        try {
          setErrormessage("");

          let confirmed = false;
          toast(
            ({ closeToast }) => (
              <ConfirmRejectToast
                onConfirm={() => {
                  confirmed = true;
                  closeToast();
                }}
                onCancel={() => {
                  confirmed = false;
                  closeToast();
                }}
              />
            ),
            {
              closeButton: false,
              className:
                "p-0 w-[400px] border border-red-500/40 rounded-md shadow-md",
              autoClose: false,
              position: "top-center",
              onClose: async () => {
                if (confirmed) {
                  try {
                    await handleManagerSubmit(
                      GoalsAssessmentFlagStatusEnumTextCap.READY,
                      IpmsData,
                    );
                  } catch (error) {
                    toast.error(
                      "Failed to reject assessment. Please try again.",
                    );
                  }
                } else {
                  toast.info("Rejection cancelled.");
                }
              },
            },
          );
        } catch (error) {
          console.error("Error rejecting assessment:", error);
        }
      } else {
        console.warn("No status provided, not rejecting assessment");
      }
    },
    [state, rejectGoalsAssessmentsData],
  );

  const trainingcolumns: Column<TrainingPlanSaveEntry>[] = [
    {
      header: "Area Of Development",
      key: "area_of_development",
      required: false,
      inputType: "textarea",
    },
    {
      header: "Action Steps",
      key: "action_steps",
      required: false,
      inputType: "textarea",
    },
    {
      header: "Timeline",
      key: "timeline",
      required: false,
      inputType: "date",
    },
  ];

  const employeeinputcolumns: Column<UpdateGoalsAssessmentsPayload>[] = [
    {
      header: "EMPLOYEE'S INPUTS (Summary of final assessment)",
      key: "employees_Inputs",
      required: false,
      inputType: "textarea",
      userRole: [USERROLEENUM.EMPLOYEE, USERROLEENUM.TSApprover],
      formTypes: ["EmployeeInput"],
      // enableSpeech: true,
    },
  ];

  const managerinputcolumns: Column<UpdateGoalsAssessmentsPayload>[] = [
    {
      header:
        "MANAGER INPUTS (Summary of final assessment of all the quarters)",
      key: "manager_Inputs",
      required: false,
      inputType: "textarea",
      userRole: [USERROLEENUM.MANAGER, USERROLEENUM.ADMIN],
      formTypes: ["ManageInput"],
      // enableSpeech: true,
    },
  ];

  const HRinputcolumns: Column<UpdateGoalsAssessmentsPayload>[] = [
    {
      header: "HR INPUTS",
      key: "hr_Inputs",
      required: true,
      inputType: "textarea",
      userRole: [USERROLEENUM.HR, USERROLEENUM.ADMIN],
      formTypes: ["ManageInput", "HRInput"],
      // enableSpeech: true,
    },
  ];

  const employee_ID = getCookieData("employee_ID");
  const handleInputChange = (
    tableKey: string,
    index: number,
    columnKey: string,
    value: string,
    qName?: string,
  ) => {
    dispatch({
      type: "UPDATE_GOAL_ASSESSMENT",
      payload: {
        tableKey,
        index,
        columnKey,
        value,
        quarterName: qName || currentQuarterKey,
      },
    });
  };

  const defaultTrainingData: trainingPlan[] = [
    {
      area_of_development: "",
      action_steps: "",
      timeline: "",
      employeeid: Number(employee_ID),
    },
  ];

  React.useEffect(() => {
    if (!GetIpmsEmployeeGoalAssessmentData || !currentQuarterKey) return;

    const currentQuarter = GetIpmsEmployeeGoalAssessmentData[currentQuarterKey];
    if (!currentQuarter || typeof currentQuarter === "string") return;

    if (!currentQuarter.training || currentQuarter.training.length === 0) {
      const updatedData = { ...GetIpmsEmployeeGoalAssessmentData };
      (updatedData[currentQuarterKey] as any).training = defaultTrainingData;
      dispatch({
        type: "SET_EMPLOYEE_GOAL_ASSESSMENT_DATA",
        payload: updatedData,
      });
    }
  }, [dispatch, GetIpmsEmployeeGoalAssessmentData]);

  const handleFinalRatingInputChange = (value: string) => {
    dispatch({
      type: "UPDATE_GOAL_ASSESSMENT",
      payload: {
        tableKey: "header",
        index: 0,
        columnKey: "final_rating",
        value: value,
        quarterName: currentQuarterKey,
      },
    });
  };

  const handleAddRow = (qName?: string) => {
    if (!GetIpmsEmployeeGoalAssessmentData) return;
    const targetQuarter = qName || currentQuarterKey;

    const newRow: TrainingPlanSaveEntry = {
      id: null,
      area_of_development: "",
      action_steps: "",
      timeline: "",
    };

    const updatedData = { ...GetIpmsEmployeeGoalAssessmentData };
    const currentQuarter = { ...updatedData[targetQuarter] } as any;
    currentQuarter.training = [...(currentQuarter.training || []), newRow];
    updatedData[targetQuarter] = currentQuarter;

    dispatch({
      type: "SET_EMPLOYEE_GOAL_ASSESSMENT_DATA",
      payload: updatedData,
    });
  };

  const handleDeleteRow = (index: number, qName?: string) => {
    if (!GetIpmsEmployeeGoalAssessmentData) return;
    const targetQuarter = qName || currentQuarterKey;

    const updatedData = { ...GetIpmsEmployeeGoalAssessmentData };
    const currentQuarter = { ...updatedData[targetQuarter] } as any;
    currentQuarter.training = currentQuarter.training.filter(
      (_: any, i: number) => i !== index,
    );
    updatedData[targetQuarter] = currentQuarter;

    dispatch({
      type: "SET_EMPLOYEE_GOAL_ASSESSMENT_DATA",
      payload: updatedData,
    });
  };

  const date = getQuarterRanges(
    moment(state?.assessmentData.start),
    moment(state?.assessmentData.end),
  );
  const renderQuarterItems = (
    quarterName: keyof GetGoalsAssessmentsResponse,
    mainIndex: number,
  ) => {
    console.log("quarterName", quarterName);
    const qData = GetIpmsEmployeeGoalAssessmentData?.[quarterName];
    if (!qData || typeof qData === "string") return null;
    const quarterIndex = Number(String(quarterName).replace("q", "")) - 1;
    console.log("qData", qData);
    return (
      <>
        <AccordionItem
          key={quarterName}
          isOpen={
            state?.quarterName === quarterName ||
            currentQuarterKey === quarterName
          }
          title={String(quarterName).toUpperCase()}
          icon={<QuestionMarkCircleIcon className="w-5 h-5 me-2 shrink-0" />}
          status={qData.header?.assessment_status}
          // dateRange={
          //   state?.id === "1,2,3,4"
          //     ? date[mainIndex - 1]
          //     : date[Number(state?.id) - 1]
          // }
          dateRange={date[quarterIndex]}
          content={
            <div>
              <GoalsAssessmentReview
                id={state?.id}
                quarterNames={quarterName as keyof QuartersResponse}
                employeeID={state?.employeeID}
                formType={state?.formType}
              />
              {quarterName === "q4" && (
                <div className="relative overflow-x-auto sm:rounded-lg mb-10 ">
                  <p className="text-white bg-gray-500 text-center font-medium ">
                    TRAINING NEEDS/DEVELOPMENT PLANS
                  </p>
                  <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                    <thead className="text-md sticky top-0 text-center text-gray-700 uppercase bg-green-200">
                      <tr>
                        <th scope="col" className="px-6 py-3 border-r">
                          SI#
                        </th>
                        {trainingcolumns.map((column, index) => (
                          <th
                            key={index}
                            scope="col"
                            className="px-6 py-3 border-r"
                          >
                            {column.header}
                            {column.required && (
                              <span className="text-red-400">*</span>
                            )}
                          </th>
                        ))}
                        <th scope="col" className="px-6 py-3">
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white dark:bg-gray-800 text-left">
                      {qData?.training &&
                        qData?.training.map((item, index) => (
                          <tr
                            key={index}
                            className="bg-white dark:bg-gray-700 border-b border-gray-200 dark:border-gray-600"
                          >
                            <th className="px-0 py-0 border-r text-center border-gray-200 dark:border-gray-600 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                              {index + 1}
                            </th>
                            <td className="px-2 border-r border-gray-200 dark:border-gray-600 text-center mt-0">
                              <SpeechTextArea
                                value={item.area_of_development}
                                disabled={
                                  [
                                    GoalsAssessmentFlagStatusEnumTextCap.APPROVED,
                                    GoalsAssessmentFlagStatusEnumTextCap.COMPLETED,
                                  ].includes(
                                    goalSubmitedAssessmentStatus as any,
                                  ) || state.formType !== "EmployeeInput"
                                }
                                onChange={(value) =>
                                  handleInputChange(
                                    "training",
                                    index,
                                    "area_of_development",
                                    value,
                                    quarterName,
                                  )
                                }
                                className="block p-2 pr-10 w-full text-sm text-gray-900 bg-white dark:bg-gray-700 dark:text-white  border-0 ring-0"
                                placeholder=""
                              />
                            </td>
                            <td className="px-2 border-r border-gray-200 dark:border-gray-600 text-center mt-0">
                              <SpeechTextArea
                                value={item.action_steps}
                                disabled={
                                  [
                                    GoalsAssessmentFlagStatusEnumTextCap.APPROVED,
                                    GoalsAssessmentFlagStatusEnumTextCap.COMPLETED,
                                  ].includes(
                                    goalSubmitedAssessmentStatus as any,
                                  ) || state.formType !== "EmployeeInput"
                                }
                                onChange={(value) =>
                                  handleInputChange(
                                    "training",
                                    index,
                                    "action_steps",
                                    value,
                                    quarterName,
                                  )
                                }
                                className="block p-2 pr-10 w-full text-sm text-gray-900 bg-white dark:bg-gray-700 dark:text-white  border-0 ring-0"
                                placeholder=""
                              />
                            </td>
                            <td className="px-2 border-r border-gray-200 dark:border-gray-600 text-center mt-0">
                              <input
                                type="date"
                                min={
                                  state?.assessmentData?.start
                                    ? moment(state.assessmentData.start).format(
                                        "YYYY-MM-DD",
                                      )
                                    : ""
                                }
                                max={
                                  state?.assessmentData?.end
                                    ? moment(state.assessmentData.end).format(
                                        "YYYY-MM-DD",
                                      )
                                    : ""
                                }
                                value={
                                  item.timeline
                                    ? moment(item.timeline).format("YYYY-MM-DD")
                                    : ""
                                }
                                disabled={
                                  [
                                    GoalsAssessmentFlagStatusEnumTextCap.APPROVED,
                                    GoalsAssessmentFlagStatusEnumTextCap.COMPLETED,
                                  ].includes(
                                    goalSubmitedAssessmentStatus as any,
                                  ) || state.formType !== "EmployeeInput"
                                }
                                onChange={(e) =>
                                  handleInputChange(
                                    "training",
                                    index,
                                    "timeline",
                                    e.target.value,
                                    quarterName,
                                  )
                                }
                                className="block p-2 w-full text-sm text-gray-900 bg-white dark:bg-gray-700 dark:text-white  border-0 ring-0"
                                placeholder=""
                              />
                            </td>
                            <td className="px-2 border-r border-gray-200 dark:border-gray-600 text-center mt-0">
                              <button
                                disabled={
                                  [
                                    GoalsAssessmentFlagStatusEnumTextCap.APPROVED,
                                    GoalsAssessmentFlagStatusEnumTextCap.COMPLETED,
                                  ].includes(
                                    goalSubmitedAssessmentStatus as any,
                                  ) || state.formType !== "EmployeeInput"
                                }
                                onClick={() =>
                                  handleDeleteRow(index, quarterName)
                                }
                                className="text-red-600 hover:text-red-800"
                              >
                                Remove
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                    <tfoot className="bg-gray-100 dark:bg-gray-700 dark:text-white py-10 text-gray-900">
                      <tr>
                        <td className="px-2 py-2 font-medium text-md text-center"></td>
                        <td className="px-2 py-2 font-medium text-md text-center"></td>
                        <td className="px-2 py-2 font-medium text-md text-center"></td>
                        <td className="px-2 py-2 font-medium text-md text-center"></td>
                        <td className="px-2 py-2 font-medium text-md text-center">
                          <button
                            onClick={() => handleAddRow(quarterName)}
                            disabled={
                              [
                                GoalsAssessmentFlagStatusEnumTextCap.APPROVED,
                                GoalsAssessmentFlagStatusEnumTextCap.COMPLETED,
                              ].includes(goalSubmitedAssessmentStatus as any) ||
                              state.formType !== "EmployeeInput"
                            }
                            className="font-medium text-blue-600 dark:text-blue-500 hover:underline "
                          >
                            Add Plans
                          </button>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              )}

              {quarterName === "q4" &&
                ![GoalsAssessmentFlagStatusEnumTextCap.READY].includes(
                  goalSubmitedAssessmentStatus as any,
                ) && (
                  <div className="">
                    <label>
                      Final Rating <span className="text-red-600">*</span>
                    </label>
                    <select
                      value={qData.header?.final_rating?.toString() ?? ""}
                      disabled={state.formType === "EmployeeInput"}
                      className="block px-3 py-2 w-lg mb-2 lg:mb-5 text-sm bg-white border dark:border-gray-600 dark:bg-gray-700 dark:text-white text-black rounded-lg "
                      onChange={(e) =>
                        handleFinalRatingInputChange(e.target.value)
                      }
                    >
                      <option value={""}>Select Rating</option>
                      {qData.assessment_scale?.map((item: any) => (
                        <option
                          key={item.rating}
                          value={item.rating?.toString()}
                        >
                          {item.rating} - {item.description}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              {quarterName === "q4" && GetIpmsEmployeeGoalAssessmentData && (
                <IPMSCustomTable
                  columns={employeeinputcolumns}
                  data={[
                    {
                      employees_Inputs: qData.header?.emp_extra_comments || "",
                    },
                  ]}
                  tableKeyName="employees_Inputs"
                  roles={userRole}
                  assessmentStatus={qData.header?.assessment_status ?? ""}
                  quarterNameData={quarterName as string}
                  formTypeRule={state.formType}
                  assessment_scale={qData.assessment_scale || []}
                />
              )}

              {quarterName === "q4" && GetIpmsEmployeeGoalAssessmentData && (
                <IPMSCustomTable
                  columns={managerinputcolumns}
                  data={[
                    {
                      manager_Inputs: qData.header?.mgr_extra_comments || "",
                    },
                  ]}
                  tableKeyName="manager_Inputs"
                  roles={userRole}
                  assessmentStatus={qData.header?.assessment_status ?? ""}
                  quarterNameData={quarterName as string}
                  formTypeRule={state.formType}
                  assessment_scale={qData.assessment_scale || []}
                />
              )}
              {quarterName === "q4" && GetIpmsEmployeeGoalAssessmentData && (
                <IPMSCustomTable
                  columns={HRinputcolumns}
                  data={[{ hr_Inputs: qData.header?.hr_extra_comments || "" }]}
                  tableKeyName="hr_Inputs"
                  roles={
                    userRole as
                      | typeof USERROLEENUM.HR
                      | typeof USERROLEENUM.ADMIN
                  }
                  assessmentStatus={qData.header?.assessment_status ?? ""}
                  quarterNameData={quarterName as string}
                  formTypeRule={state.formType}
                  assessment_scale={qData.assessment_scale || []}
                />
              )}
              {state.formType === "EmployeeInput" && (
                <AssessmentFileUpload
                  reviewId={qData?.header?.id || 0}
                  employeeId={state?.employeeID}
                  disabled={[
                    GoalsAssessmentFlagStatusEnumTextCap.APPROVED,
                    GoalsAssessmentFlagStatusEnumTextCap.COMPLETED,
                  ].includes(goalSubmitedAssessmentStatus as any)}
                  onFileUploaded={(file) => {
                    console.log("File uploaded:", file);
                  }}
                />
              )}
            </div>
          }
        />
      </>
    );
  };

  return (
    <div id="accordion-open" data-accordion="open">
      {state?.formType === "ManageInput" && !goalSubmitedStatus && (
        <p className="text-sm text-red-500">
          Employee not submitted the goal assessment
        </p>
      )}
      {state?.formType === "ManageInput" &&
        goalSubmitedAssessmentStatus &&
        goalSubmitedAssessmentStatus ===
          GoalsAssessmentFlagStatusEnumTextCap.READY && (
          <p className="text-sm text-red-500">
            Employee saved the goal assessment but not submitted
          </p>
        )}
      {goalSubmitedStatus &&
        goalSubmitedAssessmentStatus ===
          GoalsAssessmentFlagStatusEnumTextCap.SUBMITTED && (
          <p className="text-sm text-red-500">
            Goal assessment submitted, waiting for approval.
          </p>
        )}
      {goalSubmitedAssessmentStatus ===
        GoalsAssessmentFlagStatusEnumTextCap.REJECTED &&
        currentQuarterData &&
        typeof currentQuarterData !== "string" &&
        (currentQuarterData.header?.final_rating === 0 ||
          currentQuarterData.header?.final_rating) && (
          <p className="text-sm text-red-500 mb-5">
            {state?.quarterName === "q4"
              ? `You have already submitted final assessment sheet. Final Rating is ${currentQuarterData.header.final_rating}`
              : `Final Rating is ${currentQuarterData.header.final_rating}`}
          </p>
        )}
      {state?.quarterName === "q4" &&
        [
          GoalsAssessmentFlagStatusEnumTextCap.SUBMITTED,
          GoalsAssessmentFlagStatusEnumTextCap.APPROVED,
          GoalsAssessmentFlagStatusEnumTextCap.COMPLETED,
        ].includes(goalSubmitedAssessmentStatus) &&
        GoalsAssessmentFinalStatusSEnum[goalSubmitedAssessmentStatus] && (
          <div className="max-w-screen-md mx-auto h-6 bg-gray-200 rounded-lg dark:bg-gray-700 mb-5">
            <div
              className={`h-6 text-sm font-medium text-white text-center py-1 leading-none rounded-lg ${
                goalSubmitedAssessmentStatus ===
                GoalsAssessmentFlagStatusEnumTextCap.COMPLETED
                  ? "bg-green-500"
                  : goalSubmitedAssessmentStatus ===
                      GoalsAssessmentFlagStatusEnumTextCap.APPROVED
                    ? "bg-blue-500"
                    : "bg-gray-400"
              }`}
              style={{
                width:
                  GoalsAssessmentFinalStatusProgressbarSEnum[
                    goalSubmitedAssessmentStatus
                  ],
              }}
            >
              {GoalsAssessmentFinalStatusSEnum[goalSubmitedAssessmentStatus]}
              {GoalsAssessmentFinalwaitingStatusSEnum[
                goalSubmitedAssessmentStatus
              ] && (
                <>
                  {" - "}
                  {
                    GoalsAssessmentFinalwaitingStatusSEnum[
                      goalSubmitedAssessmentStatus
                    ]
                  }
                </>
              )}
            </div>
          </div>
        )}
      {state?.quarterName !== "q4" &&
        GoalsAssessmentFinalStatusSEnumother[
          goalSubmitedAssessmentStatus as any
        ] && (
          <div className="max-w-screen-md mx-auto  h-6 bg-gray-200 rounded-lg dark:bg-gray-700 mb-5">
            <div
              className={`h-6 text-sm font-medium text-white  text-center py-1 leading-none rounded-lg ${
                goalSubmitedAssessmentStatus ===
                GoalsAssessmentFlagStatusEnumTextCap.COMPLETED
                  ? "bg-green-500"
                  : goalSubmitedAssessmentStatus ===
                      GoalsAssessmentFlagStatusEnumTextCap.APPROVED
                    ? "bg-blue-500"
                    : "bg-gray-400"
              }`}
              style={{
                width:
                  GoalsAssessmentFinalStatusProgressbarSEnumOther[
                    goalSubmitedAssessmentStatus as any
                  ],
              }}
            >
              {
                GoalsAssessmentFinalStatusSEnumother[
                  goalSubmitedAssessmentStatus as any
                ]
              }
              {GoalsAssessmentFinalStatuswaitingSEnumother[
                goalSubmitedAssessmentStatus as any
              ] && (
                <>
                  {" - "}
                  {
                    GoalsAssessmentFinalStatuswaitingSEnumother[
                      goalSubmitedAssessmentStatus as any
                    ]
                  }
                </>
              )}
            </div>
          </div>
        )}
      {GetIpmsEmployeeGoalAssessmentData &&
        Object.entries(
          GetIpmsEmployeeGoalAssessmentData as GetGoalsAssessmentsResponse,
        ).map(
          ([quarterName], index) =>
            ["q1", "q2", "q3", "q4"].includes(quarterName) && (
              <div key={quarterName}>
                {["q1", "q2", "q3", "q4"].includes(quarterName) &&
                  renderQuarterItems(
                    quarterName as keyof QuartersResponse,
                    index + 1,
                  )}
              </div>
            ),
        )}
      {state?.formType === "ManageInput" && !goalSubmitedStatus && (
        <p className="text-sm text-red-500">
          Employee not submitted the goal assessment
        </p>
      )}
      {state.formType !== "EmployeeInput" &&
        goalSubmitedAssessmentStatus &&
        goalSubmitedAssessmentStatus ===
          GoalsAssessmentFlagStatusEnumTextCap.READY && (
          <p className="text-sm text-red-500">
            Employee saved the goal assessment but not submitted
          </p>
        )}
      {state.formType === "EmployeeInput" &&
        goalSubmitedAssessmentStatus &&
        goalSubmitedAssessmentStatus ===
          GoalsAssessmentFlagStatusEnumTextCap.SUBMITTED && (
          <p className="text-sm text-red-500">
            Employee Goal assessment submitted, waiting for approval.
          </p>
        )}
      {/* {goalSubmitedAssessmentStatus === GoalsAssessmentFlagStatusEnumTextCap.APPROVED &&
        currentQuarterData && typeof currentQuarterData !== "string" && (currentQuarterData.header?.final_rating === 0 || currentQuarterData.header?.final_rating) && (
          <p className="text-sm text-red-500 mb-5">
            {state?.quarterName === "q4"
              ? `You have already submitted final assessment sheet. Final Rating is ${currentQuarterData.header.final_rating}`
              : `Final Rating is ${currentQuarterData.header.final_rating}`}
          </p>
        )}

      <p className="text-sm text-red-500">{errorMessage}</p> */}
      {state?.quarterName === "q4" &&
        goalSubmitedAssessmentStatus ===
          GoalsAssessmentFlagStatusEnumTextCap.APPROVED &&
        currentQuarterData &&
        typeof currentQuarterData !== "string" &&
        (currentQuarterData.header?.final_rating === 0 ||
          currentQuarterData.header?.final_rating) && (
          <p className="text-sm text-red-500 mb-5">
            You have already submitted final assessment sheet. Final Rating is{" "}
            {currentQuarterData.header.final_rating}
          </p>
        )}
      <p className="text-sm text-red-500">{errorMessage}</p>
      {!isViewOnly && (
        <div className="py-10  text-right">
          <>
            {state.formType === "EmployeeInput" &&
              ![
                GoalsAssessmentFlagStatusEnumTextCap.SUBMIT,
                GoalsAssessmentFlagStatusEnumTextCap.APPROVED,
                GoalsAssessmentFlagStatusEnumTextCap.COMPLETED,
              ].includes(
                currentQuarterData && typeof currentQuarterData !== "string"
                  ? (currentQuarterData.header?.assessment_status ?? "")
                  : "",
              ) && (
                <button
                  onClick={() =>
                    handleEmployeeSubmit(
                      "Save",
                      GetIpmsEmployeeGoalAssessmentData as any,
                    )
                  }
                  className="inline-flex items-center px-4  mr-2 py-2 bg-blue-600 text-sm font-medium text-white border-0 border-blue-200 rounded-lg hover:bg-gray-100 hover:text-blue-600 "
                >
                  Save
                </button>
              )}
            {state.formType === "ManageInput" &&
              [GoalsAssessmentFlagStatusEnumTextCap.SUBMITTED].includes(
                currentQuarterData && typeof currentQuarterData !== "string"
                  ? (currentQuarterData.header?.assessment_status ?? "")
                  : "",
              ) && (
                <button
                  onClick={() =>
                    handleManagerSubmit(
                      GoalsAssessmentFlagStatusEnumTextCap.APPROVED,
                      GetIpmsEmployeeGoalAssessmentData as any,
                    )
                  }
                  className="inline-flex items-center px-4  mr-2 py-2 bg-black text-sm font-medium text-white border-0 border-blue-200 rounded-lg hover:bg-gray-100 hover:text-black"
                >
                  Approve
                </button>
              )}
            {/* <div className="mb-6 border-t pt-6">
              <AssessmentFileViewer
                reviewId={
                  currentQuarterData && typeof currentQuarterData !== "string"
                    ? currentQuarterData?.header?.id || 0
                    : 0
                }
                employeeId={state?.employeeID || 0}
                enableDownload={true}
              />
            </div> */}
            {state.formType === "EmployeeInput" &&
              ![
                GoalsAssessmentFlagStatusEnumTextCap.SUBMIT,
                GoalsAssessmentFlagStatusEnumTextCap.APPROVED,
                GoalsAssessmentFlagStatusEnumTextCap.COMPLETED,
              ].includes(
                currentQuarterData && typeof currentQuarterData !== "string"
                  ? (currentQuarterData.header?.assessment_status ?? "")
                  : "",
              ) && (
                <button
                  onClick={() =>
                    handleEmployeeSubmit(
                      "Submit",
                      GetIpmsEmployeeGoalAssessmentData as any,
                    )
                  }
                  className="inline-flex items-center px-4  mr-2 py-2 bg-black text-sm font-medium text-white border-0 border-blue-200 rounded-lg hover:bg-gray-100 hover:text-black"
                >
                  Submit
                </button>
              )}
          </>

          {(state?.quarterName === "q4" ||
            String(state?.quarterName) === "4") &&
            state.formType === "ManageInput" &&
            [USERROLEENUM.HR, USERROLEENUM.ADMIN].includes(userRole as any) &&
            [GoalsAssessmentFlagStatusEnumTextCap.APPROVED].includes(
              goalSubmitedAssessmentStatus,
            ) && (
              <button
                onClick={() =>
                  handleHrSubmit(
                    GoalsAssessmentFlagStatusEnumTextCap.COMPLETED,
                    GetIpmsEmployeeGoalAssessmentData as any,
                  )
                }
                className="inline-flex items-center px-4  mr-2 py-2 bg-black text-sm font-medium text-white border-0 border-blue-200 rounded-lg hover:bg-gray-100 hover:text-black"
              >
                HR Approve
              </button>
            )}
          {state.formType === "ManageInput" &&
            goalSubmitedAssessmentStatus !==
              GoalsAssessmentFlagStatusEnumTextCap.READY && (
              <button
                onClick={() =>
                  rejectGoalsAssessment(
                    GoalsAssessmentFlagStatusEnumTextCap.READY,
                    GetIpmsEmployeeGoalAssessmentData as any,
                  )
                }
                className="inline-flex items-center px-4  mr-2 py-2 bg-red-600 text-sm font-medium text-white border-0 border-blue-200 rounded-lg hover:bg-gray-100 hover:text-red-600"
              >
                Reject
              </button>
            )}

          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center px-4  mr-2 py-2 bg-red-600 text-sm font-medium text-white border-0 border-blue-200 rounded-lg hover:bg-gray-100 hover:text-red-600"
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};
// Thin route wrapper — reads location.state and passes to GoalsAssessmentContent
const GoalsAssessmentPage: React.FC = () => {
  const location = useLocation();
  const state = location.state as GoalsAssessmentContentProps;
  return <GoalsAssessmentContent {...state} />;
};
export default GoalsAssessmentPage;

export function ConfirmRejectToast({
  onConfirm,
  onCancel,
  title,
}: {
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
}) {
  return (
    <div className="w-full bg-white rounded-sm p-2">
      <p className="text-lg text-zinc-700  mb-4">
        {title ?? "Are you sure you want to reject this assessment?"}
      </p>
      <div className="flex justify-start gap-4">
        <button
          onClick={onConfirm}
          className="text-red-600 hover:text-red-700 font-medium"
        >
          Confirm
        </button>
        <button
          onClick={onCancel}
          className="text-zinc-500 hover:text-zinc-700 font-medium"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
